<section class="cz-login" *ngIf="language$ | async as language">
    <header class="header">
        <div class="container-fluid">
            <div class="row middle-xs">
                <div class="col-xs-8">
                    <div class="row middle-xs">
                        <div class="col-xs-3">
                            <img src="/assets/images/global/Comfort-Zone-Logo.png" alt="Comfort Zone" />
                        </div>
                        <div class="col-xs-9">
                            <!-- <h1 class="no-margin h3 tag">Welcome to the Acme Human Resources Comfort Zone</h1> -->
                            <h1 class="no-margin h3 tag truncate" [innerHTML]="'$login_tagline' | translate"></h1>
                        </div>
                    </div>
                </div>
                <div class="col-xs-4 end-xs partner-logo-container" *ngIf="logoHref && logoHref.length > 1">
                    <img class="partner-logo" src="{{logoHref}}" alt="Partner logo" />
                </div>
            </div>
        </div>
    </header>

    <mat-card class="login-card" *ngIf="showLoginCard()">
        <mat-toolbar color="primary">
            <mat-toolbar-row>
                <h2 *ngIf="displayLoginContent" [innerHTML]="'$header_your_options' | translate" class="truncate"></h2>
                <h2 *ngIf="displayForgotPasswordContent" [innerHTML]="'$login_card_password_help_label' | translate" class="truncate"></h2>
                <h2 *ngIf="displayUsernameHelpContent" [innerHTML]="'$login_card_username_help_label' | translate" class="truncate"></h2>
                <h2 *ngIf="displayNoAccountHelpContent" [innerHTML]="'$login_card_no_account_label' | translate" class="truncate"></h2>
                <h2 *ngIf="displayLicenseExpiredContent" [innerHTML]="'$login_card_license_expired_label' | translate" class="truncate"></h2>
            </mat-toolbar-row>
        </mat-toolbar>
        <mat-card-content>

            <!-- Initial Login Content -->
            <div class="row" *ngIf="displayLoginContent">
                <div class="col-xs-12">
                    <form [formGroup]="loginGroup">
                        <p class="error login-error-message font-weight-bold" *ngIf="authError$ | async as error">{{error.errorResponse.error.message}}</p>
                        <!-- <mat-form-field class="form-field form-full-width-field">
                            <mat-label [innerHTML]="'$user_name' | translate"></mat-label>
                            <input matInput [formControl]="username" (keyup.enter)="login()" required>
                            <mat-error *ngIf="username.invalid" [innerHTML]="'$login_card_email_input_error' | translate"></mat-error>
                        </mat-form-field>
                        <mat-form-field class="form-field form-full-width-field">
                            <mat-label [innerHTML]="'$login_card_password_input_label' | translate"></mat-label>
                            <input matInput [type]="hidePassword ? 'password' : 'text'" [formControl]="password" (keyup.enter)="login()" required>
                            <mat-icon matSuffix (click)="hidePassword = !hidePassword">{{hidePassword ? 'visibility' : 'visibility_off'}}
                            </mat-icon>
                            <mat-error *ngIf="password.invalid" [innerHTML]="'$login_card_password_input_error' | translate">
                            </mat-error>
                        </mat-form-field> -->
                        <div class="row action-buttons middle-xs between-xs">
                            <div class="col-xs-8">
                                <p class="cookie-message" [innerHTML]="'$login_card_cookies_label' | translate"></p>
                                <mat-checkbox [formControl]="cookieControl" (change)="toggleCookieAcceptance()" class="check-cookies">
                                    &nbsp;<span [innerHTML]="'$login_card_cookies_checkbox' | translate"></span></mat-checkbox>
                            </div>
                            <div class="col-xs-4 end-xs">
                              <button mat-flat-button color="accent" [disabled]="!cookieControl.value" (click)="doneClick()" [innerHTML]="'$btn_done' | translate"
                              *ngIf="!(authError$ | async)"></button>
                            </div>
                        </div>
                        <div class="row help-links bottom-xs">
                            <div class="col-xs-3">

                            </div>
                            <div class="col-xs-3">

                            </div>
                            <div class="col-xs-3">

                            </div>
                            <div *ngIf="languageArray.length>1" class="col-xs-3">
                                <!-- Updated language variable  -->
                                <cz-language-translation [langSelected]="langSelected" [language]="languageArray" (selectionChanged)="refreshLanguages($event)">
                                </cz-language-translation>
                            </div>
                        </div>
                    </form>
                </div>
                <!-- Social login - Future release -->
                <!-- <div class="col-xs-5">
          <ul class="vendor-signin">
            <li>
              <a href="#">
                <img src="/assets/images/global/icons/vendor/ico-google.jpg" />
                Sign in with Google
              </a>
            </li>
            <li>
              <a href="#">
                <img src="/assets/images/global/icons/vendor/ico-microsoft.jpg" />
                Sign in with Microsoft Online
              </a>
            </li>
          </ul>
        </div> -->
            </div>

            <!-- Forgot password email/username -->
            <div *ngIf="displayForgotPasswordContent">
                <form [formGroup]="resetPasswordGroup">
                    <div class="row">
                        <div class="col-xs">
                            <h5 class="question-label" [innerHTML]="'$login_card_password_help_message' | translate"></h5>
                            <mat-form-field class="form-field form-full-width-field">
                                <mat-label [innerHTML]="'$login_card_email_input_label' | translate"></mat-label>
                                <input matInput [formControl]="resetUsername" required>
                                <mat-error *ngIf="resetUsername.errors.required" [innerHTML]="'$login_card_email_input_error' | translate">
                                </mat-error>
                                <mat-error *ngIf="resetUsername.errors.incorrect" >
                                    <span>{{minDays}} </span><span [innerHTML]="'$password_requirement_min_age_ error'  | translate"> </span>
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <!-- <div class="row bg-red" *ngIf="isResetPasswordError">
            <span>Password Updated Recently..Can't Update Password</span>
          </div> -->
                    <div class="row action-buttons middle-xs">
                        <div class="col-xs-8">
                            <button mat-button color="accent" (click)="showLoginContent()" [innerHTML]="'$login_card_return_to_login' | translate"></button>
                        </div>
                        <div class="col-xs end-xs">
                            <button mat-flat-button color="accent" (click)="resetPassword()" [innerHTML]="'$btn_submit' | translate"></button>
                        </div>
                    </div>
                </form>
            </div>

            <!-- Forgot password/username submitted -->
            <div *ngIf="displayForgotPasswordSubmittedContent">
                <div class="row center-xs">
                    <div class="col-xs">
                        <h5 class="question-label" [innerHTML]="'$login_card_password_help_success_message' | translate"></h5>
                    </div>
                </div>
                <div class="row action-buttons center-xs">
                    <div class="col-xs">
                        <button mat-flat-button color="accent" (click)="showLoginContent()" [innerHTML]="'$login_card_return_to_login' | translate"></button>
                    </div>
                </div>
            </div>

            <!-- Username help -->
            <div *ngIf="displayUsernameHelpContent">
                <div class="row center-xs">
                    <div class="col-xs">
                        <h5 class="question-label" [innerHTML]="'$login_card_username_help_message' | translate"></h5>
                    </div>
                </div>
                <div class="row action-buttons center-xs">
                    <div class="col-xs">
                        <button mat-flat-button color="accent" (click)="showLoginContent()" [innerHTML]="'$login_card_return_to_login' | translate"></button>
                    </div>
                </div>
            </div>

            <!-- License Expired -->
            <div *ngIf="displayLicenseExpiredContent">
                <div class="row center-xs">
                    <div class="col-xs">
                        <h5 class="question-label" [innerHTML]="'$license_key_desc' | translate"></h5>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs">
                        <mat-form-field class="form-full-width-field">
                            <mat-label [innerHTML]="'$license_key' | translate"></mat-label>
                            <input matInput [formControl]="licenseKeyControl">
                        </mat-form-field>
                    </div>
                </div>
                <div class="row action-buttons center-xs">
                    <div class="col-xs">
                        <button mat-flat-button color="accent" (click)="updateLicenseKey()" [innerHTML]="'$license_key_desc' | translate"></button>
                    </div>
                </div>
            </div>

            <!-- No account help -->
            <div *ngIf="displayNoAccountHelpContent">
                <div class="row center-xs">
                    <div class="col-xs">
                        <h5 class="question-label" [innerHTML]="'$login_card_username_help_message' | translate"></h5>
                    </div>
                </div>
                <div class="row action-buttons center-xs">
                    <div class="col-xs">
                        <button mat-flat-button color="accent" (click)="showLoginContent()" [innerHTML]="'$login_card_return_to_login' | translate"></button>
                    </div>
                </div>
            </div>
        </mat-card-content>
    </mat-card>


    <footer class="footer">
        <p class="text-center font-size-small no-margin">
            <span (click)="termsOfUseDialog()" [innerHTML]="'$login_footer_terms_label' | translate"></span> | <span (click)="privacyPolicyDialog()" [innerHTML]="'$login_footer_privacy_policy_label' | translate"></span>
        </p>
    </footer>
</section>
